import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Skeleton from '@material-ui/lab/Skeleton';

const ShowMovieCardSkeleton = props => {
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));

  return (
    <div className="show-movie-card-skeleton" {...props}>
      <Skeleton width="100%" height={downXs ? 156 : 360} variant="rect" />
      <Skeleton width="100%" height={40} />
    </div>
  );
};

export default React.memo(ShowMovieCardSkeleton);
